import { render, staticRenderFns } from "./WidgetSettingsContainerForm.vue?vue&type=template&id=506f0274"
import script from "./WidgetSettingsContainerForm.vue?vue&type=script&lang=js"
export * from "./WidgetSettingsContainerForm.vue?vue&type=script&lang=js"
import style0 from "./WidgetSettingsContainerForm.vue?vue&type=style&index=0&id=506f0274&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports